import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";

export default function useIsCareerServicesDashboardEnabled(): boolean {
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();

  return flagsLoaded && flags["backoffice-career-services-dashboard"] === true;
}
